import {render} from 'solid-js/web'

import {App} from './App'

import './global-style/index.css'

render(
    () => <App />,
    document.getElementById('app-root')
)
